/* eslint-disable eqeqeq */
/* eslint-disable no-bitwise */
import axios from 'axios'
import request from '../../index'

const Global: any = global
// 登录注册接口文档
interface LoginOne {
  country_code: string // 获取当前 language 或者 region
  password: string
  code?: string
  name: string
  client_id: string // HuaMi
  redirect_uri: string // 随便填一个，用不到
  state: string // REDIRECTION
  token: string // access、refresh
  json_response: boolean // 是否以 JSON 字符串返回结果
}

interface LoginSec {
  third_name: string
  app_name: string
  grant_type: string
  code: string // 上一个接口成功后返回的 access
  device_id: string // 随便填一个
  device_model: string // 随便填一个
  app_version: string // 随便填一个
  country_code: string // 获取当前 language 或者 region
  // allow_registration // 是否需要
  dn: string
}

interface DeveloperCert {
  contactAddress: string // 联系地址
  contactMailbox: string // 联系邮箱
  contactName?: string // 联系人姓名
  contactNumber?: string // 联系电话
  name: string // '企业全称' | '真实姓名' | '机构团体'
  number?: string // 证件号码
  registeredAddress?: string // 注册地址
  state: 0 | 1 | 2 // 0:企业 1:个人 2:其他
  userId: string // 用户 ID
  certificates: Array<string> // 证书照片
  certifyType?: number
}

interface ILoginOut {
  login_token: string
}

interface RetrievePassword {
  new: string
  old?: string
  reset?: string
}

interface ResetPassword {
  key?: string
  code?: string
}
export interface IUpdateUserInfo {
  iconUrl?: string // 头像 url
  nickName?: string // 昵称，长度 1-20
  userIntroduction?: string // 个人简介，长度 1-50
}

function changeParams(params: any) {
  let spliceParams = ''
  for (const key in params) {
    if (spliceParams !== '') {
      spliceParams = `${spliceParams}&${key}=${params[key]}`
    } else {
      spliceParams = `${key}=${params[key]}`
    }
  }
  return encodeURI(spliceParams)
}

function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

// 登录 第一步
export function loginOne(userAccount: string, params: LoginOne, isPhone: boolean) {
  const data = changeParams(params)
  // const env = process.env.NODE_ENV
  return request(`${Global.hostConfig.apiUser}registrations/${isPhone ? encodeURIComponent('+86') : ''}${userAccount}/tokens`, {
    method: 'POST',
    data,
    headers: {
      app_name: 'com.huami.webapp',
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Request-Id': guid()
    }
  })
}

// 登录 第二步 需要传 dn
export function loginSec(params: LoginSec) {
  const data = changeParams({
    ...params,
    allow_registration: false
  })
  return request(`${Global.hostConfig.account}v2/client/login`, {
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  })
}

// 退出登录
export function loginOut(params: ILoginOut) {
  const data = changeParams(params)
  return axios(`${Global.hostConfig.account}v1/client/logout`, {
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 注册流程：
// 1、校验手机或邮箱是否已存在（如已存在则提示是否登录）
// 2- phone、手机号没注册则校验验证码
// 2- email 用户注册
// 3、注册 Register

// 校验账号是否已存在: 返回 404 表示账号没有注册[检测到未注册的手机号并切注册地是中国大陆，会发送一条验证码]
export function checkAccountHas(userAccount: string, isPhone?: boolean) {
  return axios({
    method: 'GET',
    url: `${Global.hostConfig.apiUser}registrations/${isPhone ? encodeURIComponent('+86') : ''}${userAccount}`,
    headers: {
      app_name: 'com.huami.webapp',
      'Accept-Language': navigator.language || 'zh-CN',
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    },
    validateStatus() {
      return true
    }
  })
}

// 校验短信验证码
export function verifyCode(userAccount: string, code: string, codeType: string) {
  const data = changeParams({ code })
  return axios(`${Global.hostConfig.apiUser}registrations/${encodeURIComponent('+86')}${userAccount}/${codeType}/verify`, {
    method: 'POST',
    data,
    headers: {
      Accept: 'application/json',
      'Accept-Language': 'zh',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    validateStatus(status) {
      if (status == 401) {
        return false
      }
      return true
    }
  })
}

// 校验图片验证码
export function verifyPicCode(key: string, code: string, type: string) {
  return axios({
    url: `${Global.hostConfig.apiUser}captcha/${type}?key=${key}&code=${code}`,
    method: 'POST',
    validateStatus() {
      return true
    }
  })
}

// 用户注册
export function registrations(userAccount: string, params: LoginOne, isPhone: boolean) {
  const data = changeParams(params)
  return axios({
    url: `${Global.hostConfig.apiUser}registrations/${isPhone ? encodeURIComponent('+86') : ''}${userAccount}`,
    method: 'POST',
    data,
    headers: {
      app_name: 'com.huami.webapp',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-Request-Id': guid()
    },
    validateStatus() {
      return true
    }
  })
}

// 注册 Register 需要传 dn
export function register(params: LoginSec) {
  const data = changeParams(params)
  return request(`${Global.hostConfig.account}v1/client/register`, {
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  })
}

// 按手机号找回: 8、7
// 按邮箱找回: 8

// 找回密码-8、重置密码
export function resetPassword(userAccount: string, params: ResetPassword, isPhone: boolean) {
  const data = changeParams(params)
  return axios(`${Global.hostConfig.apiUser}registrations/${isPhone ? encodeURIComponent('+86') : ''}${userAccount}/password`, {
    method: 'DELETE',
    data,
    headers: {
      app_name: 'com.huami.webapp',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Accept-Language': navigator.language || 'zh-CN',
      'X-Request-Id': guid()
    },
    validateStatus() {
      return true
    }
  })
}

// 找回密码-7、修改密码
// TODO：错误处理
export function retrievePassword(userAccount: string, params: RetrievePassword, isPhone: boolean) {
  const data = changeParams(params)
  return axios(`${Global.hostConfig.apiUser}registrations/${isPhone ? encodeURIComponent('+86') : ''}${userAccount}/password`, {
    method: 'POST',
    data,
    headers: {
      'X-Request-Id': guid(),
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Accept-Language': navigator.language || 'zh-CN'
    },
    validateStatus() {
      return true
    }
  })
}

// 开发者认证(需要传 token )
export function submitDeveloperCert(params: DeveloperCert, apptoken: string) {
  return axios(`${Global.hostConfig.zuul}v2/developer`, {
    method: 'POST',
    data: params,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      appname: 'com.huami.webapp',
      appVersion: '4.3.0',
      Apptoken: apptoken,
      appPlatform: '',
      Authorization: '',
      'X-Request-Id': guid()
    },
    validateStatus() {
      return true
    }
  })
}

// 获取支付宝身份验证结果(需要传 token )
export function queryDeveloperCertResult(apptoken: string) {
  return axios(`${Global.hostConfig.zuul}v2/developer/certified`, {
    method: 'GET',
    data: 'params',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      appname: 'com.huami.webapp',
      appVersion: '4.3.0',
      Apptoken: apptoken,
      appPlatform: '',
      Authorization: '',
      'X-Request-Id': guid()
    }
  })
}

// 获取用户基本信息
export function getUserInfoFromInterface(userid: string, apptoken: string) {
  return axios(`${Global.hostConfig.userInfoHost}users/${userid}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      appname: 'com.xiaomi.hm.health',
      // appname: 'com.huami.webapp',
      apptoken,
      Accept: '*/*'
    },
    validateStatus() {
      return true
    }
  })
}

// 获取用户注册地信息
export function userRegistration(userid: string, apptoken: string) {
  return axios(`${Global.hostConfig.account}admin/users/${userid}/profile`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apptoken}`,
      'X-Request-Id': guid()
    },
    validateStatus() {
      return true
    }
  })
}

// 保存用户信息
export function saveUserInfo(userid: string, apptoken: string, params: IUpdateUserInfo) {
  return axios(`${Global.hostConfig.userInfoHost}users`, {
    method: 'POST',
    data: { ...params, userId: userid },
    headers: {
      'Content-Type': 'application/json',
      apptoken,
      Accept: '*/*'
    },
    timeout: 5000,
    validateStatus() {
      return true
    }
  })
}

// 更新用户信息
export function updateUserInfo(userid: string, apptoken: string, params: IUpdateUserInfo) {
  return axios(`${Global.hostConfig.userInfoHost}users/${userid}`, {
    method: 'PUT',
    data: { ...params, userId: userid },
    headers: {
      'Content-Type': 'application/json',
      appname: 'com.xiaomi.hm.health',
      apptoken,
      Accept: '*/*'
    },
    timeout: 5000,
    validateStatus() {
      return true
    }
  })
}

// 修改开发者信息
export function updateDeveloperInfo(displayName: string, apptoken: string) {
  return axios(`${Global.hostConfig.zuul}v2/developer/modify`, {
    method: 'PUT',
    data: { displayName },
    headers: {
      'Content-Type': 'application/json',
      apptoken,
      Accept: '*/*'
    },
    timeout: 5000,
    validateStatus() {
      return true
    }
  })
}

// 上传文件 https://apihub.huami.com/project/181/interface/api/14465
export function getFileAccessURIs(userid: string, apptoken: string, fileName: string, fileType = 'PICTURE', appName = 'com.xiaomi.hm.health') {
  return axios(`${Global.hostConfig.userInfoHost}users/${userid}/apps/${appName}/fileAccessURIs`, {
    method: 'POST',
    data: { fileName, fileType },
    headers: {
      'Content-Type': 'application/json',
      appname: 'com.xiaomi.hm.health',
      apptoken,
      Accept: '*/*'
    },
    timeout: 5000,
    validateStatus() {
      return true
    }
  })
}

// 根据 putURI 上传文件
export function uploadByPutURI(putURI: string, file: any) {
  return axios(putURI, {
    method: 'PUT',
    data: file,
    headers: {
      'Content-Type': file.type,
      Accept: '*/*'
    }
  })
}
